<template lang="pug">
  .expiration
    p.date.value(v-if="date") DATE: {{date}}
    p.reason.value(v-if="reason") REASON: {{reason}}
</template>
<script>
export default {
  props: {
    expiration: {
      type: Object,
      default: () => ({
        date: null,
        reason: null,
      }),
    },
  },
  computed: {
    date () {
      return this.expiration.date
    },
    reason () {
      return this.expiration.reason
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../../assets/styles/variables.styl"

  .expiration
    display flex
    flex-direction column
    align-items flex-start
    line-height 1.5

    .date
      margin-bottom 5px

    .value
      font-weight 500
      line-height 1.5rem
      color $default-color-bold-1

</style>



// WEBPACK FOOTER //
// src/components/record-details/table-components/ExpirationBlock.vue